export const groups = [
  {
    title: "profile_info",
    data: [
      { key: "year", value: "" },
      // { key: "patient_num", value: "" },
      // { key: "ticket_ref_num", value: "" },
      // { key: "use_ticket_ref_num", value: "" },
      // { key: "insured_num", value: "" },
      // { key: "kana_name", value: "" },
      // { key: "kanji_name", value: "" },
      // { key: "date_of_birth", value: "" },
      { key: "sex", value: "" },
      { key: "age", value: "" },
      // { key: "postal_code", value: "" },
      // { key: "address", value: "" },
      // { key: "apartment_num", value: "" },
      // { key: "phone", value: "" },
      // { key: "email", value: "" },
    ],
  },
  {
    title: "healthcheck_info",
    data: [
      { key: "medical", value: "" },
      { key: "health_checkup_date", value: "" },
      { key: "metabolic_syndrome", value: "" },
      { key: "health_guidance_level", value: "" },
      { key: "health_guide", value: "" },
      { key: "doctor_diagnosis", value: "" },
      { key: "instructions_doctor", value: "" },
    ],
  },
  {
    title: "body_measure",
    data: [
      { key: "height", value: "" },
      { key: "body_weight", value: "" },
      { key: "bmi", value: "" },
      { key: "waist_circum", value: "" },
    ],
  },
  {
    title: "medical_history_title",
    data: [
      { key: "history_present_illness", value: "" },
      { key: "medical_history", value: "" },
      { key: "medical_history_kidney", value: "" },
    ],
  },
  {
    title: "examination",
    data: [
      { key: "subjective_symptoms", value: "" },
      { key: "objective_symptoms", value: "" },
    ],
  },
  {
    title: "blood_pressure",
    data: [
      { key: "maximum_blood_pressure", value: "" },
      { key: "minimum_blood_pressure", value: "" },
    ],
  },
  {
    title: "lipid_test",
    data: [
      { key: "neutral_fat", value: "" },
      { key: "hdl_cholesterol", value: "" },
      { key: "ldl_cholesterol", value: "" },
    ],
  },
  {
    title: "liver_test",
    data: [
      { key: "got_ast", value: "" },
      { key: "gpt_alt", value: "" },
      { key: "y_gpt", value: "" },
    ],
  },
  {
    title: "blood_sugar_test",
    data: [
      { key: "fasting_blood_glucose", value: "" },
      { key: "random_blood_glucose", value: "" },
      { key: "hba1c", value: "" },
    ],
  },
  {
    title: "kidney_function",
    data: [
      { key: "creatinine", value: "" },
      { key: "egfr", value: "" },
    ],
  },
  {
    title: "urinalysis",
    data: [
      { key: "axit_uric", value: "" },
      { key: "diabetes", value: "" },
      { key: "urine_protein", value: "" },
    ],
  },
  {
    title: "anemia_test",
    data: [
      { key: "hematocrit", value: "" },
      { key: "hemoglobin_content", value: "" },
      { key: "red_blood_cells_num", value: "" },
      { key: "white_blood_cells_num", value: "" },
      { key: "platelet", value: "" },
    ],
  },
  {
    title: "electrocardiogram",
    data: [
      { key: "electro_cardiogram", value: "" },
      { key: "electro_cardiogram_diagno", value: "" },
    ],
  },
  {
    title: "ophthalmoscopy",
    data: [
      { key: "fundus_eye_check", value: "" },
      { key: "fundus_eye_check_diabetes", value: "" },
    ],
  },
  {
    title: "medication",
    data: [
      { key: "medica_blood_pressure", value: "" },
      { key: "medica_blood_sugar", value: "" },
      { key: "medica_fat", value: "" },
    ],
  },
  {
    title: "health_condition_title",
    data: [
      { key: "health_condition", value: "" },
      { key: "sleep_rest", value: "" },
      { key: "waking_up_refreshed", value: "" },
    ],
  },
  {
    title: "weight_fluctuation",
    data: [
      { key: "weight_change", value: "" },
      { key: "weight_change_up_down", value: "" },
      { key: "one_weight_change", value: "" },
      { key: "one_weight_change_up_down", value: "" },
    ],
  },
  {
    title: "activity",
    data: [
      { key: "exercise_more_min", value: "" },
      { key: "life_activities", value: "" },
      { key: "walking_speed", value: "" },
    ],
  },
  {
    title: "eat_and_drink",
    data: [
      { key: "eating_speed", value: "" },
      { key: "three_meals_day", value: "" },
      { key: "skip_breakfast", value: "" },
      { key: "eat_drink_before_bed", value: "" },
      { key: "snack_after_dinner", value: "" },
      { key: "main_main_minor", value: "" },
      { key: "sweets", value: "" },
      { key: "drinking_frequency", value: "" },
      { key: "alcohol_consumed_num", value: "" },
      { key: "smoking", value: "" },
    ],
  },
];
